import { Utils } from '../utils';
import httpClient from '../utils/httpClient';

export const getQuestionary = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/anesthetist-questionary/fields`,
		headers: {
			authorization: Utils.getAuthToken()
		}
	});

	return { data, error };
};

export const answerQuestionary = async filter => {
	const { data, error } = await httpClient({
		method: 'post',
		url: `/anesthetist-questionary/answer`,
		headers: {
			authorization: Utils.getAuthToken()
		},
		data: filter
	});

	return { data, error };
};

export const submitInsuranceCard = async filter => {
	const { data, error } = await httpClient({
		method: 'post',
		url: `/anesthetist-questionary/insurance-card`,
		headers: {
			authorization: Utils.getAuthToken()
		},
		data: filter
	});

	return { data, error };
};